import {getAxiosInstance} from '../helpers/axios-helper'
import {formatBillingEventsForFront} from '../helpers/admin-helper'

const baseUrl = process.env.BACKEND_URL

function getBillingEvents() {
  return getAxiosInstance().get(`${baseUrl}/billingEvents`)
        .then(billingEventsData => {
          return formatBillingEventsForFront(billingEventsData.data)
        })
        .catch(err => {
          console.error(err)
          throw err
        })
}

function updateSessionTenantId(tenantId) {
  return getAxiosInstance().put(`${baseUrl}/authTokens/${tenantId}/updateSessionTenantId`)
        .then(response => {
          return response.data
        })
        .catch(err => {
          console.error(err)
          throw err
        })
}

function purgeBillingEvents() {
  return getAxiosInstance().delete(`${baseUrl}/purgeBillingEvents`)
        .then((data) => data)
        .catch(err => {
          if (err.response.status === 403) {
            throw new Error(err.response.data.message)
          } else {
            throw new Error('Sorry we are unable to serve your request :(')
          }
        })
}

export default {
  getBillingEvents,
  purgeBillingEvents,
  updateSessionTenantId,
}
